import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CustomerServiceRequirementFormComponent } from "./customer-service-requirement-form/customer-service-requirement-form.component";
import { CustomerServiceRequirementListComponent } from "./customer-service-requirement-list/customer-service-requirement-list.component";

const routes: Routes = [
    {
        path: '',
        data: { title: 'Customer Service Requirement' },
        component: CustomerServiceRequirementListComponent
    },
    {
        path: 'add',
        data: { title: 'Add Customer Service Requirement' },
        component: CustomerServiceRequirementFormComponent
    },
    {
        path: 'edit/:id',
        data: { title: 'Edit Customer Service Requirement' },
        component: CustomerServiceRequirementFormComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CustomerServiceRequirementRoutingModule { }
